import React, { useRef, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Formik, Form, Field } from "formik";

export default function ModalPut({
  showPerfil,
  departmentId,
  onClose,
  company,
  ActualizarDatosPerfil,
  Validaciones,
  sectorList,
  departments,
  municipalities,
  getMunicipality,
}) {
  const hasSubmit = useRef(false);

  useEffect(() => {
    if (company?.departmentId?.departmentId) {
      if (isNaN(parseInt(company?.departmentId?.departmentId))) {
        return;
      }

      getMunicipality(parseInt(company?.departmentId?.departmentId));
    }

    //eslint-disable-next-line
  }, [company]);

  useEffect(() => {
    if (!showPerfil) {
      getMunicipality(parseInt(company?.departmentId?.departmentId));
    }

    //eslint-disable-next-line
  }, [showPerfil]);

  return (
    <Modal
      show={showPerfil}
      onHide={onClose}
      keyboard={false}
      dialogClassName="kr-modal"
    >
      <Modal.Body>
        <div className="form form--white ">
          <Formik
            initialValues={{
              aboutUs: company.aboutUs,
              employes: company.employes,
              fundation: company.fundation,
              genderPoliciesUs: company.genderPoliciesUs,
              linkFacebook: company.linkFacebook,
              linkInstagram: company.linkInstagram,
              linkTwitter: company.linkTwitter,
              mission: company.mission,
              name: company.name,
              sectorId:
                company.sectorId === undefined ? 1 : company.sectorId.sectorId,
              slogan: company.slogan,
              ubication: company.ubication,
              municipality: company?.municipality ?? "",
              valuesUs: company.valuesUs,
              webSite: company.webSite,
              departmentId: company?.departmentId?.departmentId,
              municipalityId: company?.municipalityId?.municipalityId,
              allies: company?.allies === 1,
            }}
            onSubmit={(values, { setSubmitting }) => {
              hasSubmit.current = true;
              setSubmitting(true);
              ActualizarDatosPerfil(values);
              setSubmitting(false);
            }}
            validationSchema={Validaciones}
          >
            {({ errors, touched, isSubmitting }) => (
              <Form>
                <div className="div__wrapper">
                  <div className="form__title text-center">Crear Perfil</div>
                  <div className="form__row">
                    <div className="col-sm-12 ">
                      <label htmlFor="webSite">Url Sitio Web</label>
                      <Field
                        type="text"
                        name="webSite"
                        id="webSite"
                        placeholder="https://tuempresa.com"
                      ></Field>
                      {errors.webSite && touched.webSite && (
                        <span className="form__validation form__validation--error">
                          {errors.webSite}
                        </span>
                      )}
                    </div>
                    <div className="col-sm-12 mt-3">
                      <label htmlFor="sectorId">
                        Sector Empresarial{" "}
                        <span className="required-input">*</span>
                      </label>
                      <Field
                        as="select"
                        type="text"
                        name="sectorId"
                        id="sectorId"
                        required
                      >
                        <option hidden selected value="">
                          Seleccione un sector
                        </option>
                        {sectorList.map((item, index) => {
                          return (
                            <option key={index} value={item.sectorId}>
                              {item.name}
                            </option>
                          );
                        })}
                      </Field>
                      {errors.sectorId && touched.sectorId && (
                        <span className="form__validation form__validation--error">
                          {errors.sectorId}
                        </span>
                      )}
                    </div>
                    <div className="col-sm-12 mt-3">
                      <label htmlFor="ubication">
                        Dirección Principal{" "}
                        <span className="required-input">*</span>
                      </label>
                      <Field
                        type="text"
                        name="ubication"
                        id="ubication"
                        required
                      ></Field>
                      {errors.ubication && touched.ubication && (
                        <span className="form__validation form__validation--error">
                          {errors.ubication}
                        </span>
                      )}
                    </div>

                    <div className="col-12 mt-3">
                      <label>
                        Departamento <span className="required-input">*</span>
                      </label>

                      <Field
                        value={departmentId}
                        onChange={({ target: { value } }) =>
                          getMunicipality(parseInt(value))
                        }
                        as="select"
                        type="text"
                        name="departmentId"
                        id="departmentId"
                        required
                      >
                        <option hidden selected value="">
                          Seleccione un departamento
                        </option>

                        {departments.map((item, index) => (
                          <option key={index} value={item.departmentId}>
                            {item.name}
                          </option>
                        ))}
                      </Field>

                      {errors.departmentId && touched.departmentId && (
                        <span className="form__validation form__validation--error">
                          {errors.departmentId}
                        </span>
                      )}
                    </div>

                    <div className="col-12 mt-3">
                      <label>
                        Municipio <span className="required-input">*</span>
                      </label>

                      <Field
                        as="select"
                        type="text"
                        name="municipalityId"
                        id="municipalityId"
                        required
                      >
                        <option hidden selected value="">
                          Seleccione un Municipio
                        </option>

                        {municipalities.map((item, index) => (
                          <option key={index} value={item.municipalityId}>
                            {item.name}
                          </option>
                        ))}
                      </Field>

                      {errors.municipalityId && touched.municipalityId && (
                        <span className="form__validation form__validation--error">
                          {errors.municipalityId}
                        </span>
                      )}
                    </div>

                    <div className="col-sm-12 mt-3">
                      <label htmlFor="employes">Empleados</label>
                      <Field type="text" name="employes" id="employes"></Field>
                      {errors.employes && touched.employes && (
                        <span className="form__validation form__validation--error">
                          {errors.employes}
                        </span>
                      )}
                    </div>
                    <div className="col-sm-12 mt-3">
                      <label htmlFor="fundation">Año de Fundación</label>
                      <Field
                        type="text"
                        className="form-control"
                        name="fundation"
                        id="fundation"
                      ></Field>
                      {errors.fundation && touched.fundation && (
                        <span className="form__validation form__validation--error">
                          {errors.fundation}
                        </span>
                      )}
                    </div>
                    <div className="col-sm-12 mt-3">
                      <label htmlFor="genderPoliciesUs">
                        Políticas de Género
                      </label>
                      <Field
                        as="textarea"
                        name="genderPoliciesUs"
                        id="genderPoliciesUs"
                      ></Field>
                      {errors.genderPoliciesUs && touched.genderPoliciesUs && (
                        <span className="form__validation form__validation--error">
                          {errors.genderPoliciesUs}
                        </span>
                      )}
                    </div>
                    <div className="col-sm-12 mt-3">
                      <label htmlFor="name">
                        Nombre <span className="required-input">*</span>
                      </label>
                      <Field type="text" name="name" id="name" required></Field>
                      {errors.name && touched.name && (
                        <span className="form__validation form__validation--error">
                          {errors.name}
                        </span>
                      )}
                    </div>
                    <div className="col-sm-12 mt-3">
                      <label htmlFor="mission">Mision</label>
                      <Field type="text" name="mission" id="mission"></Field>
                      {errors.mission && touched.mission && (
                        <span className="form__validation form__validation--error">
                          {errors.mission}
                        </span>
                      )}
                    </div>
                    <div className="col-sm-12 mt-3">
                      <label htmlFor="slogan">Eslogan</label>
                      <Field type="text" name="slogan" id="slogan"></Field>
                      {errors.slogan && touched.slogan && (
                        <span className="form__validation form__validation--error">
                          {errors.slogan}
                        </span>
                      )}
                    </div>
                    <div className="col-sm-12 mt-3">
                      <label htmlFor="valuesUs">Valores</label>
                      <Field type="text" name="valuesUs" id="valuesUs"></Field>
                      {errors.valuesUs && touched.valuesUs && (
                        <span className="form__validation form__validation--error">
                          {errors.valuesUs}
                        </span>
                      )}
                    </div>
                    <div className="col-sm-12 mt-3">
                      <label htmlFor="linkInstagram">Instagram</label>
                      <Field
                        type="text"
                        name="linkInstagram"
                        id="linkInstagram"
                        placeholder="https://instagram.com/perfil"
                      ></Field>
                      {errors.linkInstagram && touched.linkInstagram && (
                        <span className="form__validation form__validation--error">
                          {errors.linkInstagram}
                        </span>
                      )}
                    </div>
                    <div className="col-sm-12 mt-3">
                      <label htmlFor="linkTwitter">Twitter</label>
                      <Field
                        type="text"
                        name="linkTwitter"
                        id="linkTwitter"
                        placeholder="https://twitter.com/perfil"
                      ></Field>
                      {errors.linkTwitter && touched.linkTwitter && (
                        <span className="form__validation form__validation--error">
                          {errors.linkTwitter}
                        </span>
                      )}
                    </div>
                    <div className="col-sm-12 mt-3">
                      <label htmlFor="linkFacebook">Facebook</label>
                      <Field
                        type="text"
                        name="linkFacebook"
                        id="linkFacebook"
                        placeholder="https://facebook.com/perfil"
                      ></Field>
                      {errors.linkFacebook && touched.linkFacebook && (
                        <span className="form__validation form__validation--error">
                          {errors.linkFacebook}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form__row"></div>

                  <div className="form__row">
                    <label htmlFor="aboutUs">Acerca de mi</label>
                    <Field
                      as="textarea"
                      type="text"
                      name="aboutUs"
                      id="aboutUs"
                    ></Field>
                    {errors.aboutUs && touched.aboutUs && (
                      <span className="form__validation form__validation--error">
                        {errors.aboutUs}
                      </span>
                    )}
                  </div>

                  <div>
                    <label htmlFor="allies">
                      <Field type="checkbox" name="allies" id="allies" />
                      &nbsp; Ser parte del programa Aliados
                    </label>
                  </div>

                  <div className="form__row">
                    <button
                      disabled={isSubmitting}
                      type="submit"
                      className="btn btn--gradient btn__icon btn__icon--door"
                    >
                      Guardar
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal.Body>
    </Modal>
  );
}
